export interface INAVLINK {
  url: string;
  title: string;
}

export const NAV_LINK_1: Array<INAVLINK> = [
  {
    url: '/services',
    title: 'Услуги'
  },
  {
    url: '/training',
    title: 'Учебный центр'
  },
  {
    url: '/events',
    title: 'Курсы и мероприятия'
  },
  {
    url: '/announcements',
    title: 'Анонсы'
  },
  {
    url: '/blog',
    title: 'Блог о закупках'
  },
];

export const NAV_LINK_2: Array<INAVLINK> = [
  {
    url: '/about',
    title: 'О нас'
  },
  {
    url: '/news',
    title: 'Новости'
  },
  {
    url: '/team',
    title: 'Наша команда'
  },
  {
    url: '/contacts',
    title: 'Контакты'
  },
  {
    url: '/vacancy',
    title: 'Вакансии'
  },
];

export const NAV_LINK_3: Array<INAVLINK> = [];
